<style scoped>

</style>
<template>
  <Drawer
    v-model="config.modal"
    width="800"
    title="员工数据导出"
  >
    <div class="line text-center">
      <Select
        v-model="params.time_item"
        placeholder="日期维度"
        style="width: 100px"
      >
        <Option value="contract_start">
          合同开始
        </Option>
        <Option value="contract_end">
          合同到期
        </Option>
        <Option value="quit_time">
          离职日期
        </Option>
      </Select>
      <DatePicker
        type="daterange"
        :options="date_option"
        placement="bottom-start"
        placeholder="日期范围"
        style="width: 150px"
        @on-change="setStartAndEnd"
      />
      <Select
        v-model="params.quit"
        placeholder="是否在职"
        style="width: 100px"
      >
        <Option :value="0">
          在职
        </Option>
        <Option :value="1">
          离职
        </Option>
        <Option :value="2">
          所有员工
        </Option>
      </Select>
      <Cascader
        :data="customer_type_data"
        placeholder="员工类别(默认所有类别)"
        style="width: 200px; display: inline-block"
        @on-change="customerTypeSelect"
      />
    </div>
    <div class="line text-center">
      <Select
        v-if="companies.length"
        v-model="params.company_id"
        placeholder="公司"
        style="width: 100px"
      >
        <Option :value="0">
          所有公司
        </Option>
        <Option
          v-for="company in companies"
          :key="company.id"
          :value="company.id"
        >
          {{ company.short_name }}
        </Option>
      </Select>
      <Select
        v-if="teams.length"
        v-model="params.team_id"
        placeholder="团队"
        style="width: 100px"
      >
        <Option :value="0">
          所有团队
        </Option>
        <Option
          v-for="team in teams"
          :key="team.id"
          :value="team.id"
        >
          {{ team.name }}
        </Option>
      </Select>
      <Select
        v-if="jobs.length"
        v-model="params.job_id"
        placeholder="团队"
        style="width: 100px"
      >
        <Option :value="0">
          所有岗位
        </Option>
        <Option
          v-for="job in jobs"
          v-show="!job.del"
          :key="job.id"
          :value="job.id"
        >
          {{ job.name }}
        </Option>
      </Select>
      <Select
        v-model="params.office_id"
        placeholder="工作地点"
        style="width: 100px"
      >
        <Option :value="0">
          所有地点
        </Option>
        <Option :value="1">
          成都
        </Option>
        <Option :value="2">
          北京
        </Option>
        <Option :value="3">
          远程
        </Option>
      </Select>
      <Button
        type="primary"
        @click="exportResource()"
      >
        <Icon type="ios-download-outline" />
        导出自定义数据
      </Button>
    </div>
  </Drawer>
</template>
<script :route="[
      {
        path: '/hr/customer_export',
        noChkout: true
      },
      {
        path: '/fin/customer_export',
        noChkout: true
      }
    ]"
>
  import Util from '../../libs/util';
  import {mapGetters} from "vuex";
  export default {
    /* router_info_start */
    router_info: [
      {
        path: '/hr/customer_export',
        noChkout: true
      },
      {
        path: '/fin/customer_export',
        noChkout: true
      }
    ],
    /* router_info_end */

    data() {
      return {
        config: {
          modal: false
        },
        params: {
          start: '',
          end: '',
          customer_type: '-1',
          time_item: 'contract_start',
          quit: 0,
          team_id: 0,
          company_id: 0,
          job_id: 0,
          office_id: 0
        },
        customer_type_data: [
          {
            value: -1,
            label: '所有类别'
          },
          {
            value: '',
            label: '正式员工',
            children: [
              {
                value: 9,
                label: '所有正式'
              },
              {
                value: 0,
                label: '正式员工'
              },
              {
                value: 1,
                label: '正式员工-实习'
              }
            ]
          },
          {
            value: 10,
            label: '实习生'
          },
          {
            value: 20,
            label: '兼职/外包'
          },
          {
            value: 30,
            label: '挂靠人员'
          },
        ],
        date_option: {
          shortcuts: [
            {
              text: '最近一周',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                return [start, end];
              }
            },
            {
              text: '最近一个月',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                return [start, end];
              }
            },
            {
              text: '最近三个月',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                return [start, end];
              }
            },
            {
              text: '最近一年',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                return [start, end];
              }
            }
          ]
        },
        // 获取列表或者搜索时
        loading: false,
      }
    },
    computed: {
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
        jobs: 'async/jobs',
        jobs_hash: 'async/jobs_hash',
        offices: 'async/offices',
        offices_hash: 'async/offices_hash',
      })
    },
    created() {
      //
    },
    methods: {
      show() {
        this.config.modal = true;
      },
      customerTypeSelect(value_arr) {
        this.params.customer_type = value_arr[value_arr.length - 1];
      },
      setStartAndEnd(date) {
        this.params.start = date[0];
        this.params.end = date[1];
      },
      exportResource() {
        if (this.loading) return;
        this.loading = true;
        Util.ajax.get(Util.api.export_customer, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.config.modal = false;
            this.$emit("done");
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      }
    }
  }
</script>
